import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

export function AuthGuard() {
  const { user, profile, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background-50">
        <div className="flex flex-col items-center gap-4">
          <div className="w-10 h-10 border-[3px] border-primary-500 border-t-transparent rounded-full animate-spin" />
          <p className="text-foreground-600 text-sm">Carregando...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    // Check if we were redirected due to expired session
    const isSessionExpired = (location.state as { sessionExpired?: boolean })?.sessionExpired;
    return (
      <Navigate
        to="/login"
        state={{
          from: location,
          sessionExpired: isSessionExpired || true,
        }}
        replace
      />
    );
  }

  // Redirect to onboarding if not completed (unless already on onboarding or subscription)
  if (profile && !profile.onboarding_completed) {
    const skipOnboarding = location.pathname === '/onboarding' || location.pathname === '/subscription' || location.pathname === '/setup-fee' || location.pathname === '/my-usage' || location.pathname.startsWith('/settings');
    if (!skipOnboarding) {
      return <Navigate to="/onboarding" replace />;
    }
  }

  return <Outlet />;
}

export function GuestGuard() {
  const { user, profile, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background-50">
        <div className="w-10 h-10 border-3 border-primary-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (user) {
    // Redirect to onboarding if not completed, otherwise to dashboard
    if (profile && !profile.onboarding_completed) {
      return <Navigate to="/onboarding" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}